<app-add-form
  data-testid="purchase-return-order-view-form"
  [title]="'purchase_return_order.view.title' | translate"
  [formFields]="formFields()"
  [tableSections]="tableSections()"
  [headerActions]="headerActions()"
  [loading]="loading()"
  [initialData]="currentFormData"
  [viewMode]="true"
  (formAction)="onFormAction($event.action)"
></app-add-form>

<!-- Toast Messages -->
<p-toast data-testid="purchase-return-order-view-toast"></p-toast>

